import { AppService } from '@ajin/services/app.service';
import { inject } from '@angular/core';
import { NavigationService } from '@projects/core/navigation/navigation.service';
import { forkJoin } from 'rxjs';
import { ajinConfig } from './ajin.config';
import { AuthService } from '@projects/core/auth/auth.service';

export const initialDataResolver = () => {
	const app = inject(AppService);
	const navigationService = inject(NavigationService);

	app.setConfig(ajinConfig);

	return forkJoin([
		app.loadCredential(),
		navigationService.load()
	]);
};
